import { render, staticRenderFns } from "./BigBanner.vue?vue&type=template&id=007b459a&"
import script from "./BigBanner.vue?vue&type=script&lang=js&"
export * from "./BigBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports